<div class="full-height">
  <div style="display: flex; height: 100%; flex-direction: row">
    <div
      style="
        height: 100%;
        flex: 0 0 270px;
        overflow-y: auto;
        padding-left: 4px;
        display: flex;
        flex-direction: column;
      "
    >
      <div class="pt-3 pb-2 text-center">
        <h2 class="m-0 p-0">
          <span *ngIf="isLoading"><i class="fa fa-spin fa-spinner"></i></span>
          <span *ngIf="!isLoading">{{ workingSet.length }} </span>
          Tasks
        </h2>
      </div>

      <div *ngIf="!showSearch" class="pr-2 mb-2" style="padding-top: 4px; text-align: center">
        <button
          (click)="showSearch = !showSearch"
          [icon]="'fa fa-filter'"
          id="task-filters"
          label="Filters"
          pButton
          style="width: 90%"
        ></button>
      </div>

      <div
        *ngIf="showSearch"
        style="flex: 0 0 50px; width: 100%; text-align: center; align-items: center"
      >
        <div>
          <div style="display: flex; flex-wrap: wrap; width: 90%">
            <div style="flex-grow: 1; padding: 4px">
              <button
                (click)="showSearch = !showSearch"
                [label]="'Show Tasks'"
                class="green-btn"
                id="intro-showtasks"
                pButton
                style="width: 100%"
              ></button>
            </div>
            <div style="flex-shrink: 1; padding: 4px">
              <button
                (click)="clearAllFilters()"
                [label]="'Clear'"
                pButton
                style="width: 100%"
              ></button>
            </div>
          </div>
        </div>
      </div>

      <div style="flex-grow: 1; overflow-y: auto; height: 100%">
        <div *ngIf="showSearch; else showResult" style="height: 100%">
          <div *ngIf="filterGroups.length > 0; else loadingFilters" class="facets-flex-wrapper">
            <div class="facets-container" id="facets-list-container">
              <div class="facets-inner-container">
                <div
                  *ngFor="let filter of filterGroups; let i = index"
                  class="facets-list"
                  id="facetslist"
                >
                  <p-panel
                    [pTooltip]="filterDefinitions[i].tooltip"
                    id="engineius-panel-{{ i }}"
                    tooltipPosition="top"
                  >
                    <p-header>
                      <div class="facet-title-bar">
                        <div (click)="isFacetOpen[i] = !isFacetOpen[i]" class="facet-title-text">
                          <span *ngIf="!isFacetOpen[i]"><i class="fa fa-caret-down"></i></span>
                          <span *ngIf="isFacetOpen[i]"><i class="fa fa-caret-up"></i></span>
                          {{ filter.name }}
                          <span
                            *ngIf="selectedFilters[i] && selectedFilters[i].length > 0"
                            [escape]="false"
                            [pTooltip]="getSelectedFiltersString(i)"
                            [tooltipStyleClass]="'xtooltip'"
                            class="p-badge filters"
                            style="text-align: center; cursor: pointer"
                            >{{ selectedFilters[i].length }}</span
                          >
                        </div>

                        <div style="flex-grow: 1">
                          <input
                            (input)="applyFilter(i, $event.target.value, 'label', 'contains')"
                            *ngIf="filterDefinitions[i].searchable"
                            [(ngModel)]="filterDefinitions[i].searchKeyword"
                            autocomplete="off"
                            class="filter-input filter-{{ filter.propertyName }}"
                            name="filter"
                          />

                          <input
                            (change)="applyInput(i, $event.target.value)"
                            *ngIf="filterDefinitions[i].input"
                            autocomplete="chrome-off"
                            [placeholder]="filterDefinitions[i].placeholder"
                            [(ngModel)]="filterDefinitions[i].searchKeyword"
                            [class]="'filter-input filter-' + filterDefinitions[i].propertyName"
                            name="filter"
                          />
                        </div>

                        <div
                          *ngIf="filterDefinitions[i].searchable"
                          class="filter-search-icon"
                          pTooltip="Filter the list by name"
                          style="flex-shrink: 1"
                        >
                          <i class="fa fa-search"></i>
                        </div>

                        <div *ngIf="isFacetLoading[i]">
                          <i class="fa fa-spin fa-spinner"></i>
                        </div>

                        <div
                          *ngIf="isFacetOpen[i] && !isFacetLoading[i]"
                          style="flex-shrink: 1; white-space: nowrap"
                        >
                          <div
                            (click)="sortFilter(i)"
                            class="filter-sort-icon"
                            pTooltip="Switch between alphabetic and 'highest count' ordering"
                          >
                            <i class="fa fa-sort"></i>
                          </div>
                        </div>
                      </div>
                    </p-header>
                    <p-table
                      selectionMode="multiple"
                      [(selection)]="selectedFilters[i]"
                      *ngIf="!isFacetLoading[i]"
                      [value]="filter.selectItems"
                      [lazy]="false"
                      (onRowSelect)="filterRowSelectionChanged(i)"
                      (onRowUnselect)="filterRowSelectionChanged(i)"
                      id="facetTable"
                      #facetTable
                      selectionMode="multiple"
                      [paginator]="false"
                      rowHover="true"
                      resizableColumns="true"
                      [metaKeySelection]="false"
                      [style]="{
                        'max-height': '200px',
                        'overflow-y': 'scroll',
                        display: isFacetOpen[i] ? 'block' : 'none'
                      }"
                      (onFilter)="handleFilter($event, facetTable.totalRecords)"
                    >
                      <ng-template pTemplate="body" let-data>
                        <tr [pSelectableRow]="data">
                          <td style="border-right-width: 0px">
                            <span
                              [ngClass]="{ 'red-label': data.dataOutOfRange }"
                              appendTo="body"
                              pTooltip="{{ data.label }}"
                              tooltipPosition="top"
                              >{{ data.label }}</span
                            >
                          </td>

                          <td style="width: 40px; text-align: right">
                            <span class="p-badge">{{ data.count }}</span>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </p-panel>
                </div>
              </div>
            </div>
          </div>

          <ng-template #loadingFilters>
            <div style="height: 100%">
              <div style="display: flex; align-items: center; height: 100%; text-align: center">
                <div style="width: 100%">
                  <div><i class="fa fa-spin fa-spinner fa-2x"></i></div>
                  <div class="pt-2"><strong>Filters Loading</strong></div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <ng-template #showResult>
          <div style="padding-top: 15px">
            <div id="resultslist-wrapper">
              <div *ngFor="let result of resultSet; let i = index" id="resultslist">
                <div class="px-1" id="intro-task-{{ i }}">
                  <div
                    (click)="selectedJobChanged(result)"
                    (dblclick)="viewJob(result.jobId)"
                    [ngClass]="isJobSelected(result.jobId) ? 'selected' : 'not-selected'"
                    class="results-grid results-list"
                  >
                    <div class="trip-info">{{ result.moveDistance }} miles</div>

                    <div
                      *ngIf="!linkedToPrevious(result) && result.buyItNowPrice > 0"
                      class="buy-now-price"
                    >
                      {{ result.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                    </div>

                    <table style="width: 100%">
                      <tr>
                        <td class="shrink-cell pick-up-color text-center">
                          <span class="pick-up-color">
                            <i class="vme-material-icons">&#xe805;</i>
                          </span>
                        </td>
                        <td>
                          <div class="date-value">
                            {{ result.earliestPickupDate | date : 'EEE dd MMM HH:mm' }}
                            - {{ result.latestPickupDate | date : 'EEE dd MMM HH:mm' }}
                          </div>
                          <div class="location">
                            {{ result.from }}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="shrink-cell drop-off-color text-center">
                          <div>
                            <i class="vme-material-icons">&#xe804;</i>
                          </div>
                        </td>
                        <td>
                          <div class="date-value">
                            {{ result.earliestDropOffDate | date : 'EEE dd MMM HH:mm' }}
                            - {{ result.latestDropOffDate | date : 'EEE dd MMM HH:mm' }}
                          </div>
                          <div class="location">
                            {{ result.to }}
                          </div>
                        </td>
                      </tr>
                    </table>
                    <div class="vrm-line">
                      <div class="vrm">{{ result.vehicleReg }}</div>
                      <div class="vehicle-info">{{ result.vehicleRegDetails }}</div>

                      <div
                        (click)="showMap($event, i, result)"
                        [id]="'jobmap-' + i"
                        class="job-map"
                      >
                        <span *ngIf="showingMap[i]">Close map</span>
                        <span *ngIf="!showingMap[i]">Show map</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="linkedJob(result)" class="linked-job">
                    Same job
                    <i class="fa fa-arrows-v"></i>
                  </div>
                  <div *ngIf="!linkedJob(result)" class="not-linked-job"></div>
                </div>
                <div
                  class="px-1 pb-3"
                  [id]="'mapcontainer-' + i"
                  style="margin-top: -20px"
                  *ngIf="showingMap[i]"
                >
                  <div style="padding-right: 4px">
                    <div class="tooltip" style="width: 100%; height: 154px">
                      <div *ngIf="loadingMap[i]">
                        <div class="spinner"><i class="fa fa-spin fa-spinner"></i> Loading map</div>
                      </div>
                      <div *ngIf="!loadingMap[i] && mapCode[i]">
                        <img [src]="mapCode[i]" alt="Map" style="width: 100%" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div style="flex-grow: 1; overflow-y: auto; display: flex">
      <div style="width: 100%; height: 100%">
        <vme-interactive-schedule
          [inputJobs]="selectedJobs"
          style="{'width': '100%'}"
        ></vme-interactive-schedule>
      </div>
    </div>
  </div>
</div>
